import React, {useState, useEffect, useMemo, useRef}		from 'react';
import {useNavigate, useParams, useSearchParams}	from 'react-router-dom';

import {CatalogProduct}								from './CatalogProduct';
import Button										from '../ressources/components/Button';
import Icon											from '../ressources/components/Icon';
import Select										from '../ressources/components/Select';
import Switch										from '../ressources/components/Switch';
import SettingsAddress								from '../Settings/SettingsAddress';
import DevicesBadges								from '../ressources/components/Badge/DevicesBadges';
import Badge										from '../ressources/components/Badge';
import Checkbox										from '../ressources/components/Checkbox';
import ModalFilter 									from '../ressources/components/ModalFilter';
import DeviceImage									from '../ressources/components/Device/DeviceImage';
import Section										from '../ressources/components/Section';
import ButtonGroup									from '../ressources/components/ButtonGroup';
import {DeviceCard}									from '../ressources/components/Device';
import ButtonStickyContainer						from '../ressources/components/Button/ButtonStickyContainer';
import Textarea										from '../ressources/components/Textarea';
import MultiInputContainer							from '../ressources/components/Input/MultiInputContainer';
import ModalCompanyBundle							from './ModalCompanyBundle';

import {useAppSelector, useAppDispatch}				from '../app/hooks';
import {postOrderApi}								from '../redux/order/order';
import {User}										from '../redux/user/interface';
import {BasketAddressList}							from '../redux/basket/interface';
import {addToBasket, basketChangeAddress, basketChangeAssign,
	openBasket, resetBasket, setBasket,
	setFullBasket}									from '../redux/basket/basket';
import {Catalog, CatalogMinimal, Filters}			from '../redux/catalog/interface';
import {clearHeader, setHeader}						from '../redux/settings/settings';
import {SelectValues}								from '../ressources/components/Select/interface';
import {DeviceType} 								from '../ressources/typescript-declaration/global';
import {FilterChecked, FilterData} 					from '../ressources/components/Modal/interface';
import {LanguageFilters} 							from '../ressources/language/type';
import {getCompanyBundleApi}						from '../redux/companyBundle/companyBundle';
import {CompanyBundle}								from '../redux/companyBundle/interface';
import {InputValues}								from '../ressources/components/Input/interface';
import {PostOrderData}								from '../redux/order/interface';

import {ft_formatAddressInline, ft_formatMemorySize,
	ft_formatPrice}									from '../ressources/functions/format';
import {ft_genNotification, ft_pushNotification}	from '../ressources/functions/notification';
import {ft_sortCatalogByPrice} 						from '../ressources/functions/filters';
import {ft_getDeviceCatalogPrice}					from '../ressources/functions/deviceFunction';
import {getLocalStorage, setLocalStorage}			from '../ressources/functions/localStorage';
import ft_cssVar									from '../ressources/functions/getCssVar';
import {ft_selectDataUser}							from '../ressources/functions/selectData';

import img_filter									from '../ressources/images/icon/filter.svg';
import img_truck									from '../ressources/images/icon/truck.svg';
import img_boxColored								from '../ressources/images/icon/box-colored.svg';
import img_pin										from '../ressources/images/pin.png';
import img_phoneHeart								from '../ressources/images/phone-heart.png';
import img_happy									from '../ressources/images/happy.png';
import img_heart									from '../ressources/images/icon/heart.svg';
import img_alert									from '../ressources/images/icon/alert-circle.svg';

import {BUTTON_GROUP_DATA}							from '../ressources/data/catalog';
import LANGUAGE										from '../ressources/language';
import * as API										from '../ressources/API';

import './OrderNew.css';
import {ft_getLinkedUnit} from '../ressources/functions/basketFunction';

interface FilterResponse {
	data?:	{
		key: keyof LanguageFilters,
		filters: [string]
	}[]
	status:	boolean
}

interface DeviceData {
	device: Catalog,
	devicesList: string[],
	assign: string[],
	keyboard?: string,
	duration: number
}

interface SortAddress {
	address: string,
	devices: DeviceData[]
}

interface modalAddressData {
	addressId: string,
	index?: number,
	duration?: number,
	keyboard?: string,
	deviceId?: string
}


function OrderNew() {
	const dispatch = useAppDispatch();
	const user = useAppSelector(state => state.user.data);
	const users = useAppSelector(state => state.companyUsers.data);
	const address = useAppSelector(state => state.address.data);
	const companyBundle = useAppSelector(state => state.companyBundle.data);
	const lang = useAppSelector(state => state.settings.lang);
	const basket = useAppSelector(state => state.basket);
	const notificationId = useAppSelector(state => state.notifications.lastId);

	const [catalog, set_catalog] = useState<CatalogMinimal[]>([]);
	const [step, set_step] = useState(1);
	const [forceUser, set_forceUser] = useState('');
	const [favorite, set_favorite] = useState<string[]>([]);

	const [menu, set_menu] = useState<DeviceType | 'favorite'>('computer');

	const [filtersData, set_filtersData] = useState<FilterData[]>([]);
	const [filters, set_filters] = useState<FilterChecked[]>([]);
	const [filterModal, set_filterModal] = useState(false);
	const [sort, set_sort] = useState<SelectValues>('');

	const [modalIdCategory, set_modalIdCategory] = useState('');
	const [modalBundle, set_modalBundle] = useState<false | CompanyBundle>(false);

	const [sameAddress, set_sameAddress] = useState(true);
	const [sameAddressId, set_sameAddressId] = useState('');
	const [modalAddress, set_modalAddress] = useState<modalAddressData | null>(null);
	const [forceUserMail, set_forceUserMail] = useState<string[]>(user?._id ? [user._id] : []);
	const [forceUserMailTracking, set_forceUserMailTracking] = useState<string[]>(user?._id ? [user._id] : []);
	const [creatorComment, set_creatorComment] = useState<InputValues>('');

	const [legalCheck, set_legalCheck] = useState(false);

	const [load, set_load] = useState(false);
	const [checkCart, set_checkCart] = useState(false);

	const mainAddress = useMemo(() => address.find(find => find.main)?._id, [address]);

	const isMenuChanging = useRef(true);

	const TEXTE = LANGUAGE(lang);
	const navigate = useNavigate();
	const params = useParams();
	const [searchParams] = useSearchParams();

	let error = false;

	useEffect(() => {
		const copy = JSON.parse(JSON.stringify(basket.data));
		let newPrice = 0;

		const checkData = (i: number) => {
			if (!copy[i]) {
				set_checkCart(true);
				return dispatch(setBasket({
					user,
					quantity:    0,
					addressList: [],
					data:        copy,
					open:        false,
					price:       newPrice
				}));
			}

			API.getCatalogById(copy[i].device._id, user)
			.then((response) => {
				if (!response?.status || response.error) {
					newPrice += parseFloat(`${copy[i].device.price}`) * copy[i].quantity;
					return checkData(i + 1);
				}

				const responsePrice = ft_getDeviceCatalogPrice(response.data, copy[i].duration) || response.data.info.price;

				if (copy[i].device.price !== responsePrice)
					copy[i].device.price = responsePrice;

				newPrice += parseFloat(`${copy[i].device.price}`) * copy[i].quantity;
				return checkData(i + 1);
			});
		};
		checkData(0);

		API.getCatalogFavorite(user)
		.then((response) => {
			if (!searchParams.get('view') && (response?.data?.length > 0 || companyBundle.length > 0))
				set_menu('favorite');
			set_favorite(response?.data || []);
		});
	}, []);

	useEffect(() => {
		if (filters.length) {
			isMenuChanging.current = true;
			set_filters([]);
		}
		const useMenu = menu === 'favorite' ? undefined : menu;

		API.getCatalog(useMenu, user)
		.then((response: {data?: CatalogMinimal[]}) => {
			if (response?.data)
				set_catalog(response.data);
		});

		API.getCatalogFilters(useMenu)
		.then((response: FilterResponse) => {
			if (!response?.status || !response.data)
				return;

			const result: FilterData[] = [];

			response.data.forEach((filter) => {
				if (filter.key === 'stockage' || filter.key === 'memory' || filter.key === 'processorCore' || filter.key === 'gpu')
					filter.filters = filter.filters.sort((a, b) => ft_formatMemorySize(a) - ft_formatMemorySize(b));
				else {
					filter.filters = filter.filters.sort((a, b) => {
						if (typeof a === 'number' && typeof b === 'number')
							return a - b;
						return a.localeCompare(b);
					});
				}

				result.push({
					name:    filter.key,
					key:     filter.key,
					filters: filter.filters
				});
			});

			set_filtersData(result);
		});

		if (menu === 'favorite')
			dispatch(getCompanyBundleApi(user));
	}, [menu]);


	useEffect(() => {
		if (isMenuChanging.current) {
			isMenuChanging.current = false;
			return;
		}

		const resultFilter: Filters = {};

		if (filters.length > 0) {
			if (menu)
				resultFilter.type = menu;

			filters.forEach(filter => resultFilter && (resultFilter[filter.key] = filter.values));
		}

		API.getCatalogFiltered(resultFilter, user)
		.then((response: {data?: CatalogMinimal[]}) => {
			if (response?.data)
				set_catalog(response.data);
		});
	}, [filters]);

	useEffect(() => {
		if (params.step === 'confirm' && basket.quantity > 0)
			return set_step(2);
		return set_step(1);
	}, [params.step]);

	useEffect(() => {
		if (BUTTON_GROUP_DATA.find(find => find.value === searchParams.get('view')))
			set_menu(searchParams.get('view') as DeviceType);
	}, [searchParams, checkCart]);

	useEffect(() => {
		const userParams = searchParams.get('user');

		if (!checkCart || !userParams || !users.some(e => e?._id === userParams))
			return;

		dispatch(setHeader({
			function: () => navigate(-1),
			render:   TEXTE.global.back
		}));

		setLocalStorage('saveCart', basket);
		dispatch(resetBasket(user));
		set_forceUser(userParams);

		return () => {
			dispatch(clearHeader());

			const save = getLocalStorage('saveCart');

			if (!save?.data)
				return;

			dispatch(setFullBasket(save));
			setLocalStorage('saveCart', '');
		};
	}, [searchParams, checkCart]);

	useEffect(() => {
		if (!sameAddressId && mainAddress)
			set_sameAddressId(mainAddress);
	}, [mainAddress]);

	useEffect(() => set_legalCheck(false), [step]);

	function editFavorite(id: string, isDelete = false) {
		const callApi = isDelete ? API.deleteCatalogFavorite(id, user) : API.putCatalogFavorite(id, user);

		callApi.then((response) => {
			if (response.data)
				set_favorite(response.data);
		});
	}

	function addOrder() {
		set_load(true);

		const addressList: BasketAddressList[] = [];

		basket.data.forEach((basketData) => {
			for (let i = 0; i < basketData.quantity; i++) {
				const useAddress = sameAddress ? sameAddressId : basketData.address[i];
				const indexAddress = addressList.findIndex(find => find.address === useAddress);

				if (indexAddress === -1) {
					addressList.push({
						address: useAddress,
						devices: [{
							quantity: 1,
							keyboard: basketData.keyboard,
							duration: basketData.duration,
							shopData: basketData.device._id,
							assign:   basketData.assign[i] ? [basketData.assign[i]] : [],
							price:    ft_getDeviceCatalogPrice(basketData.device, basketData.duration)
						}]
					});
				} else {
					const indexDevice = addressList[indexAddress].devices.findIndex(find => find.shopData === basketData.device._id && find.keyboard === basketData.keyboard && find.duration === basketData.duration);

					if (indexDevice !== -1) {
						addressList[indexAddress].devices[indexDevice].quantity++;

						if (basketData.assign[i])
							addressList[indexAddress].devices[indexDevice].assign.push(basketData.assign[i]);
					} else {
						addressList[indexAddress].devices.push({
							quantity: 1,
							keyboard: basketData.keyboard,
							duration: basketData.duration,
							shopData: basketData.device._id,
							assign:   basketData.assign[i] ? [basketData.assign[i]] : [],
							price:    ft_getDeviceCatalogPrice(basketData.device, basketData.duration)
						});
					}
				}
			}
		});

		const notifications: PostOrderData['forceUserMail'] = [];

		if (forceUserMailTracking.length)
			forceUserMailTracking.forEach(e => notifications.push({_id: e, type: 'tracking'}));
		if (forceUserMail.length)
			forceUserMail.forEach(e => notifications.push({_id: e, type: 'management'}));

		// --- Post User
		dispatch(postOrderApi({data: {addressList, forceUserMail: notifications, creatorComment}, user}))
		.then(async (response) => {
			if (!response?.payload?._id)
				return set_load(false);

			const notificationData = ft_genNotification(TEXTE, 'addOrderSuccess', img_truck, `n°${response.payload.number}`);
			ft_pushNotification(dispatch, notificationId, notificationData);

			set_load(false);
			dispatch(resetBasket(user));
			navigate(`/order/${response.payload._id}`);
		});
	}

	function addBundleToBasket(bundle: CompanyBundle) {
		if (!bundle)
			return;

		bundle.bundle.forEach((data) => {
			if (data.category.legacy)
				return;

			dispatch(addToBasket({
				user,
				quantity:  1,
				duration:  36,
				device:    data,
				addressId: mainAddress
				// keyboard:  selectedOptions['keyboard'] as string,
			}));
		});

		dispatch(openBasket());
	}

	function assignBasketDevice(deviceData: DeviceData, index: number, assignUser?: User) {
		const newId = assignUser?._id || '';

		const assign = (device: Catalog, keyboard: string | undefined, duration: number, i: number) => {
			dispatch(basketChangeAssign({
				user,
				newId,
				index:    i,
				keyboard,
				duration,
				deviceId: device._id
			}));
		};

		assign(deviceData.device, deviceData.keyboard, deviceData.duration, index);

		const entry = basket.data.find(find => (
			find.device._id === deviceData.device._id
		&& find.keyboard === deviceData.keyboard
		&& find.duration === deviceData.duration
		));
		const linked = entry && ft_getLinkedUnit(basket.data, {entry, index});

		if (linked)
			assign(linked.entry.device, linked.entry.keyboard, linked.entry.duration, linked.index);
	}

	function renderMenu() {
		return (
			<Section>
				<div className={'globalDataContainerItem'}>
					<ButtonGroup
						actual={menu}
						data={
							[
								{
									value:  'favorite',
									render: <Icon icon={img_heart} iconColor={ft_cssVar('error-500')} />
								},
								...BUTTON_GROUP_DATA
							]
						}
						styleItem={{padding: '2px 4px', width: 42}}
						onClick={value => set_menu(value as DeviceType)}
					/>

					<div className={'flex'} />

					<Button
						size={'sm'}
						type={'tertiary-gray'}
						iconBefore={img_filter}
						onClick={() => set_filterModal(true)}
					>
						{TEXTE.global.filter}
						{filters.length > 0 &&
							<Badge
								size={'sm'}
								color={'gray'}
								text={filters.length}
							/>
						}
					</Button>

					<div className={'globalListHeaderSeparator'} />

					<Button
						size={'sm'}
						valueAbsolute={sort}
						type={'tertiary-gray'}
						onChangeAbsolute={set_sort}
						absolute={[
							{value: 'ascendingPrice', render: TEXTE.global.sortAscendingPrice},
							{value: 'decreasingPrice', render: TEXTE.global.sortDecreasingPrice}
						]}
						style={{marginRight: 20}}
					>
						{TEXTE.global.sortBy}
					</Button>
				</div>
			</Section>
		);
	}

	function renderBundleList() {
		const render: React.ReactElement[] = [];

		companyBundle.forEach((bundle) => {
			const images: React.ReactElement[] = [];
			let monthly = 0;

			bundle.bundle.forEach((data, i) => {
				monthly += data.price || 0;

				if (i < 4) {
					images.push(
						<DeviceImage catalog={data} className={'orderNewDeviceCardImage'} imageFormat={'small'} />
					);
				}
			});

			render.push(
				<div
					style={{cursor: 'pointer'}}
					className={'orderNewDeviceCard'}
					onClick={() => set_modalBundle(bundle)}
				>
					{bundle.bundle.some(e => e.category.legacy) &&
						<Icon
							icon={img_alert}
							className={'orderNewDeviceCardHeart'}
							popup={TEXTE.order.bundle.legacyPopup}
						/>
					}

					<div className={'orderNewDeviceCardMultiImage'}>
						{images}
					</div>

					<span className={'orderNewDeviceCardName'}>{bundle.name}</span>
					<span className={'orderNewDeviceCardText'}>{`${ft_formatPrice(monthly)}/${TEXTE.global.month}`}</span>

					<Button
						fullWidth
						size={'sm'}
						onClick={(e) => {
							e?.stopPropagation();
							addBundleToBasket(bundle);
						}}
					>
						{TEXTE.order.addBasket}
					</Button>
				</div>
			);
		});

		return (
			<>
				<span className={'text-xl weight-600'}>{'Pack'}</span>
				<div className={'orderNewDevicesListContainer'}>
					{render}
					{render.length === 0 ?
						<div className={'flex flex-center'}>
							<span className={'text-xl weight-600 gray-700'}>{'Aucun pack'}</span>
						</div>
						:
						<>
							<div className={'orderNewDeviceCard empty'} />
							<div className={'orderNewDeviceCard empty'} />
							<div className={'orderNewDeviceCard empty'} />
							<div className={'orderNewDeviceCard empty'} />
						</>
					}
				</div>
				<div className={'separator'} style={{marginBottom: 16}} />
			</>
		);
	}

	function renderDevicesList() {
		const render: React.ReactElement[] = [];

		ft_sortCatalogByPrice(catalog, sort as string, favorite).forEach((device) => {
			const isFavorite = favorite.some(e => e === device.category?._id);

			if (menu === 'favorite' && !isFavorite)
				return;

			render.push(
				<div className={'orderNewDeviceCard'}>
					<Icon
						icon={img_heart}
						className={'orderNewDeviceCardHeart'}
						iconColor={ft_cssVar(isFavorite ? 'error-400' : 'gray-300')}
						onClick={() => editFavorite(device.category?._id || '', isFavorite)}
					/>

					<DeviceImage catalog={device} className={'orderNewDeviceCardImage'} imageFormat={'medium'} />

					<span className={'orderNewDeviceCardName'}>{device.name}</span>
					<span className={'orderNewDeviceCardText'}>{`${TEXTE.order.priceStart}${ft_formatPrice(device.lowestPrice)}/${TEXTE.global.month}`}</span>

					<Button
						fullWidth
						size={'sm'}
						onClick={() => device.category && set_modalIdCategory(device._id)}
					>
						{TEXTE.order.seeOptions}
					</Button>
				</div>
			);
		});

		return (
			<div>
				{menu === 'favorite' && renderBundleList()}
				<div className={`orderNewDevicesListContainer ${(menu === 'favorite' && render.length === 0) && 'flex'}`}>
					{render}
					{(menu === 'favorite' && render.length === 0) ?
						<div className={'flex flex-center'}>
							<span className={'text-xl weight-600 gray-700'}>{'Aucun favori'}</span>
						</div>
						:
						<>
							<div className={'orderNewDeviceCard empty'} />
							<div className={'orderNewDeviceCard empty'} />
							<div className={'orderNewDeviceCard empty'} />
							<div className={'orderNewDeviceCard empty'} />
						</>
					}
				</div>
			</div>
		);
	}

	function renderTotalLine() {
		return (
			<>
				<div
					style={{marginBottom: 8}}
					className={'globalDataContainerItem column text-xs weight-500 gray-600'}
				>
					<div className={'flex'}>
						<span className={'flex'}>{TEXTE.global.subTotal}</span>
						<span>{`${ft_formatPrice(basket.price)} HT/${TEXTE.global.month}`}</span>
					</div>
					<div className={'flex'}>
						<span className={'flex'}>{TEXTE.global.delivery}</span>
						<span>{TEXTE.global.free}</span>
					</div>
				</div>

				<div className={'globalDataContainerItem text-xs weight-500 gray-600'}>
					<span className={'flex'}>{TEXTE.global.total}</span>
					<span>
						<span className={'text-xl weight-600 gray-800'}>{ft_formatPrice(basket.price)}</span>
						<span className={'text-sm'}>{` HT/${TEXTE.global.month}`}</span>
					</span>
				</div>
			</>
		);
	}

	function renderAddressSelection() {
		const render: React.ReactElement[] = [];

		if (sameAddress || basket.quantity === 1) {
			const actualAddress = address.find(find => find._id === sameAddressId);

			if (!actualAddress)
				error = true;

			render.push(
				<Section className={'globalDataContainerItem'} style={{marginBottom: 0}}>
					<DevicesBadges basket />

					<div className={'orderNewAddressItemSelect'}>
						<Select
							value={1}
							data={[{value: 1, render: ft_formatAddressInline(actualAddress)}]}
							onClick={() => set_modalAddress({addressId: actualAddress?._id || ''})}
						/>
					</div>

					<div className={'text-lg gray-800 weight-600'}>
						{ft_formatPrice(basket.price)}<span className={'gray-600'}>{`/${TEXTE.global.month}`}</span>
					</div>
				</Section>
			);
		} else {
			basket.data.forEach((basketData) => {
				for (let i = 0; i < basketData.quantity; i++) {
					const actualAddress = address.find(find => find._id === basketData.address[i]);
					const price = ft_getDeviceCatalogPrice(basketData.device, basketData.duration);

					if (!actualAddress && !sameAddress && basket.quantity !== 1)
						error = true;

					render.push(
						<DeviceCard
							showPrice
							price={price}
							shopData={basketData.device}
							actualAddress={actualAddress}
							addressSelect={!sameAddress && basket.quantity !== 1}
							onClickAddress={() => {
								set_modalAddress({
									index:     i,
									duration:  basketData.duration,
									keyboard:  basketData.keyboard,
									deviceId:  basketData.device._id,
									addressId: actualAddress?._id || ''
								});
							}}
						/>
					);
				}
			});
		}

		return (
			<>
				<div className={'globalAddHeader'}>
					<Icon
						iconSize={35}
						icon={img_boxColored}
						iconColor={'#000000'}
					/>
					<div className={'globalAddHeaderText'}>
						<span className={'text-xl weight-600 gray-900'}>{TEXTE.order.selectAddress}</span>
						<span className={'text-sm weight-400 gray-600'}>{TEXTE.order.selectAddressText}</span>

						{basket.quantity !== 1 &&
							<Switch
								active={sameAddress}
								style={{marginTop: 12}}
								text={TEXTE.order.sendSameAddress}
								onChange={() => set_sameAddress(!sameAddress)}
							/>
						}
					</div>
				</div>

				<Section style={{gap: '10px'}} >
					{render}
				</Section>

				{renderTotalLine()}

				<br />
				<Section className={'globalDataContainerItem column'} style={{gap: '10px'}} >
					<MultiInputContainer>
						<Select
							arrayUseRender
							value={forceUserMail}
							title={TEXTE.order.userMail}
							data={ft_selectDataUser(users)}
							checkboxChecked={value => !!forceUserMail.find(find => find === value)}
							onClickCheckbox={(value) => {
								const copy = [...forceUserMail];
								const index = copy.findIndex(find => find === value);

								if (index === -1)
									copy.push(value as string);
								else
									copy.splice(index, 1);

								set_forceUserMail(copy);
							}}
						/>
						<Select
							arrayUseRender
							value={forceUserMailTracking}
							title={TEXTE.order.userMailTracking}
							data={ft_selectDataUser(users)}
							checkboxChecked={value => !!forceUserMailTracking.find(find => find === value)}
							onClickCheckbox={(value) => {
								const copy = [...forceUserMailTracking];
								const index = copy.findIndex(find => find === value);

								if (index === -1)
									copy.push(value as string);
								else
									copy.splice(index, 1);

								set_forceUserMailTracking(copy);
							}}
						/>
					</MultiInputContainer>
					<Textarea
						value={creatorComment}
						title={TEXTE.order.comment}
						onChange={set_creatorComment}
					/>
				</Section>

				<ButtonStickyContainer>
					<Button
						fullWidth
						type={'tertiary-gray'}
						onClick={() => navigate('/order/add')}
					>
						{TEXTE.order.backCatalog}
					</Button>
					<Button
						fullWidth
						disabled={error}
						onClick={() => set_step(3)}
					>
						{TEXTE.order.validAndContinue}
					</Button>
				</ButtonStickyContainer>
			</>
		);
	}

	function renderRecap() {
		const render: React.ReactElement[] = [];
		const sortAddress: SortAddress[] = [];
		let disabled = !legalCheck;

		basket.data.forEach((basketData) => {
			for (let i = 0; i < basketData.quantity; i++) {
				const useAddress = sameAddress ? sameAddressId : basketData.address[i];
				const indexAddress = sortAddress.findIndex(find => find.address === useAddress);
				const deviceId = i.toString();

				if (indexAddress === -1) {
					sortAddress.push({
						address:     useAddress,
						devices: [{
							devicesList: [deviceId],
							device:      basketData.device,
							duration:    basketData.duration,
							keyboard:    basketData.keyboard,
							assign:      [basketData.assign[i]]
						}]
					});
				} else {
					const indexDevice = sortAddress[indexAddress].devices.findIndex(find => find.device._id === basketData.device._id && find.keyboard === basketData.keyboard && find.duration === basketData.duration);

					if (indexDevice !== -1) {
						sortAddress[indexAddress].devices[indexDevice].devicesList.push(deviceId);
						sortAddress[indexAddress].devices[indexDevice].assign.push(basketData.assign[i]);
					} else {
						sortAddress[indexAddress].devices.push({
							devicesList: [deviceId],
							device:      basketData.device,
							duration:    basketData.duration,
							keyboard:    basketData.keyboard,
							assign:      [basketData.assign[i]]
						});
					}
				}
			}
		});

		sortAddress.forEach((addressData) => {
			const actualAddress = address.find(find => find._id === addressData.address);

			render.push(
				<div className={'orderNewRecapTextLine'}>
					<img src={img_pin} alt={''} />
					<span>{TEXTE.global.address}{' '}<span>{ft_formatAddressInline(actualAddress, true)}</span></span>
					<img src={img_phoneHeart} alt={''} />
					<span>{TEXTE.global.contact}{' '}<span>{`${actualAddress?.firstname} ${actualAddress?.lastname} ${actualAddress?.phone}`}</span></span>
					<img src={img_boxColored} alt={''} />
					<span>{TEXTE.global.delivery}{' '}<span>{TEXTE.order.deliveryDay}</span></span>
				</div>
			);

			addressData.devices.forEach((deviceData) => {
				deviceData.devicesList.forEach((deviceId, i) => {
					const isEsim = deviceData.device.info.format === 'E-SIM';
					const price = ft_getDeviceCatalogPrice(deviceData.device, deviceData.duration);

					if (isEsim && !deviceData.assign[i])
						disabled = true;

					render.push(
						<DeviceCard
							showPrice
							resetAssign
							price={price}
							key={`device-${deviceId}`}
							shopData={deviceData.device}
							assign={deviceData.assign[i]}
							forceAssign={deviceData.device.info.format === 'E-SIM'}
							onClickAssign={assignUser => assignBasketDevice(deviceData, parseInt(deviceId, 10), assignUser)}
						/>
					);

					if (isEsim && !deviceData.assign[i]) {
						render.push(
							<div style={{display: 'flex', alignItems: 'center', gap: 8, marginTop: -12}}>
								<Icon icon={img_alert} />
								<p>{TEXTE.order.esimAssign}</p>
							</div>
						);
					}
				});
			});
		});

		const legal = TEXTE.order.legalText;

		return (
			<>
				<div className={'globalAddHeader'}>
					<img src={img_happy} width={35} alt={''} />

					<div className={'globalAddHeaderText'}>
						<span className={'text-xl weight-600 gray-900'}>{TEXTE.order.orderEnd}</span>
						<span className={'text-sm weight-400 gray-600'}>{TEXTE.order.orderEndText}</span>
						<span className={'text-sm weight-400 gray-600'}>{TEXTE.order.orderEndTextPart2}</span>
					</div>
				</div>

				<Section style={{gap: 8}}>
					{render}
				</Section>

				<Section>
					{renderTotalLine()}
				</Section>

				<Checkbox
					active={legalCheck}
					onChange={set_legalCheck}
					text={
						<span>
							{legal.readAccept}
							<a href={'https://www.valala-shop.fr/cgv'} target={'_blank'} rel={'noreferrer'}>{legal.generalCondition}</a>
							{legal.asWellAs}
							<a href={'https://www.valala-shop.fr/politique-rgpd'} target={'_blank'} rel={'noreferrer'}>{legal.dataProtection}</a>
							{legal.and}
							<a href={'https://www.valala-shop.fr/cga'} target={'_blank'} rel={'noreferrer'}>{legal.insuranceCondition}</a>
						</span>
					}
				/>
				<br />

				<ButtonStickyContainer>
					<Button
						fullWidth
						disabled={load}
						type={'tertiary-gray'}
						onClick={() => set_step(2)}
					>
						{TEXTE.global.previous}
					</Button>
					<Button
						fullWidth
						isLoad={load}
						onClick={addOrder}
						disabled={disabled}
					>
						{TEXTE.order.validateOrder}
					</Button>
				</ButtonStickyContainer>
			</>
		);
	}

	return (
		<div className={'globalDataContainer'}>
			{step === 1 && renderMenu()}
			{step === 1 && renderDevicesList()}

			{step === 2 && renderAddressSelection()}

			{step === 3 && renderRecap()}

			{modalIdCategory &&
				<CatalogProduct
					mainAddress={mainAddress}
					forceUser={forceUser}
					deviceId={modalIdCategory}
					onClose={() => set_modalIdCategory('')}
				/>
			}

			{modalAddress &&
				<SettingsAddress
					modal
					initialValue={modalAddress.addressId}
					onClose={() => set_modalAddress(null)}
					onConfirm={(newVal) => {
						if (modalAddress.index !== undefined && modalAddress.deviceId && modalAddress.duration) {
							dispatch(basketChangeAddress({
								user,
								newId:    newVal,
								index:    modalAddress.index,
								deviceId: modalAddress.deviceId,
								keyboard: modalAddress.keyboard,
								duration: modalAddress.duration
							}));
						} else
							set_sameAddressId(newVal);

						set_modalAddress(null);
					}}
				/>
			}

			{filterModal &&
				<ModalFilter
					filters={filters}
					setFilters={set_filters}
					customFilter={filtersData}
					onClose={() => set_filterModal(false)}
				/>
			}

			{modalBundle &&
				<ModalCompanyBundle
					forceBundle={modalBundle}
					onClose={() => {
						set_modalBundle(false);
						dispatch(getCompanyBundleApi(user));
					}}
				/>
			}
		</div>
	);
}

export default OrderNew;
